(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter"] && !Shopify.designMode) return;
  try {
    // Copia del testo Coupon
  document.addEventListener('DOMContentLoaded', function() {
    const copyButton = document.getElementById('copyCoupon');
    const couponInput = document.getElementById('couponCode');
    const copyMessage = document.getElementById('copyMessage');

    if (copyButton && couponInput) {
      copyButton.addEventListener('click', function() {
        // Seleziona e copia il testo
        couponInput.select();
        couponInput.setSelectionRange(0, 99999); // Per mobile
        
        // Copia negli appunti
        navigator.clipboard.writeText(couponInput.value).then(function() {
          // Rimuovi la selezione blu
          couponInput.blur();
          window.getSelection().removeAllRanges();
          
          // Mostra il messaggio di successo
          copyMessage.style.display = 'block';
          
          // Nascondi il messaggio dopo 3 secondi
          setTimeout(function() {
            copyMessage.style.display = 'none';
          }, 3000);
        }).catch(function(err) {
          console.error('Errore nella copia:', err);
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
